import { createClient } from '@supabase/supabase-js';

/**
 * Client Supabase unique de l'app (US-501 : couche d'accès données centralisée).
 * Plus aucune requête SQL inline dans les composants (audit dette D8).
 */
const url = import.meta.env.VITE_SUPABASE_URL as string;
const anonKey = import.meta.env.VITE_SUPABASE_ANON_KEY as string;

export const supabase = createClient(url, anonKey);
